// Formatting helpers for the UPB Match Explorer.
// Org rules: thousands commas on counts/currency, percentages to 1 decimal,
// currency with a $ prefix, dates as MM/DD/YY.

export const fmtInt = n =>
  n === null || n === undefined ? '—' : Number(n).toLocaleString('en-US');

export const fmtPct = n => (n === null || n === undefined ? '—' : `${Number(n).toFixed(1)}%`);

export const fmtUsd = n =>
  n === null || n === undefined ? '—' : `$${Math.round(Number(n)).toLocaleString('en-US')}`;

export const fmtScore = n => (n === null || n === undefined ? '—' : Number(n).toFixed(1));

// Format a numeric value by DP-metric type ('int' | 'score' | 'usd').
export const formatByType = (type, value) => {
  if (type === 'usd') {
    return fmtUsd(value);
  }
  if (type === 'score') {
    return fmtScore(value);
  }
  return fmtInt(value);
};

// 'YYYY-MM-DD' -> 'MM/DD/YY'
export const fmtDate = iso => {
  if (!iso) {
    return '';
  }
  const [year, month, day] = iso.split('-');
  return `${month}/${day}/${year.slice(2)}`;
};
